import * as React from "react";

const SvgArrowsGreen = (props) => (
  <svg
    className="arrows-green_svg__arrows-green"
    viewBox="0 0 429 229"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      d="M0-14.466h-46.829v-4.915c0-1.04-.587-1.981-1.531-2.457a2.87 2.87 0 0 0-2.931.209L-68.794-9.398a2.751 2.751 0 0 0-1.182 2.247c0 .89.442 1.73 1.183 2.248l17.502 12.231a2.858 2.858 0 0 0 2.931.208 2.744 2.744 0 0 0 1.531-2.455V.165H0c1.557 0 2.822-1.238 2.822-2.761v-9.109c0-1.523-1.265-2.761-2.822-2.761"
      style={{
        fill: "#8cc23e",
        fillRule: "nonzero",
      }}
      transform="translate(291.567 195.694) scale(4.16667)"
    />
    <path
      d="M0 14.801h46.829v4.915c0 1.04.587 1.98 1.53 2.456.41.206.853.307 1.293.307.577 0 1.15-.174 1.639-.516L68.793 9.732a2.75 2.75 0 0 0 1.184-2.247c0-.89-.444-1.73-1.184-2.247L51.291-6.993a2.857 2.857 0 0 0-2.931-.209 2.744 2.744 0 0 0-1.531 2.456V.169H0c-1.557 0-2.822 1.239-2.822 2.762v9.108c0 1.523 1.265 2.762 2.822 2.762"
      style={{
        fill: "#0f6837",
        fillRule: "nonzero",
      }}
      transform="translate(137.111 31.294) scale(4.16667)"
    />
  </svg>
);

export default SvgArrowsGreen;
